import React from "react";
import { Panel, Table, Loader } from "@culturehq/components";
import * as CHQ from "chq";

import { useGet } from "app/hooks";
import { EventLink } from "app/links";
import { Trans } from "app/utils";

import { Time } from "components/common/Time";

import Sentiment from "./Sentiment";

type EventResponseProps = {
  response: CHQ.EventResponse;
};

const EventResponse: React.FC<EventResponseProps> = ({ response }) => (
  <tr>
    <td className="w-20">
      <div className="flx-column">
        <EventLink event={response.event} />
        <Time time={response.event.startsAt} format="%Y-%m-%d" />
      </div>
    </td>
    <td className="w-20">
      <Time time={response.createdAt} format="%Y-%m-%d" />
    </td>
    <td className="w-40">{response.body}</td>
    <td className="w-10 txt-center">
      <Sentiment sentiment={response.sentiment} />
    </td>
  </tr>
);

const EventResponsesTable: React.FC = ({ children }) => (
  <Table className="table-responsive">
    <thead>
      <tr>
        <th className="w-20">
          <Trans>Event</Trans>
        </th>
        <th className="w-20">
          <Trans>Date</Trans>
        </th>
        <th className="w-40">
          <Trans>Response</Trans>
        </th>
        <th className="w-10">
          <Trans>Sentiment</Trans>
        </th>
      </tr>
    </thead>
    <tbody>
      {children}
    </tbody>
  </Table>
);

export type ListEventResponses = {
  responses: CHQ.EventResponse[];
};

const EventResponses: React.FC = () => {
  const get = useGet<ListEventResponses>("/analytics/events/responses");

  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw get.error;
  }

  if (get.got.responses.length === 0) {
    return (
      <EventResponsesTable>
        <tr>
          <td colSpan={3} align="center">
            <Trans>No data</Trans>
          </td>
        </tr>
      </EventResponsesTable>
    );
  }

  return (
    <EventResponsesTable>
      {get.got.responses.map(response => (
        <EventResponse key={response.id} response={response} />
      ))}
    </EventResponsesTable>
  );
};

const EventFeedback: React.FC = () => (
  <Panel>
    <Panel.Body className="card_holder">
      <div className="card_title">
        <h3>
          <Trans>Latest Feedback</Trans>
        </h3>
      </div>
      <div className="card_info">
        <EventResponses />
      </div>
    </Panel.Body>
  </Panel>
);

export default EventFeedback;
